export default class Viewport {
    constructor() {
        this.$ = $ || window.jQuery;
        this.win = $(window);

        this.winWidth = ('innerWidth' in window) ? window.innerWidth : (document.documentElement || document.body).clientWidth;
        this.winHeight = ('innerHeight' in window) ? window.innerHeight : (document.documentElement || document.body).clientHeight;
    }

    /**
     *  Returns true if window scrollTop is zero, or less then the specified offset
     *
     * @param {number} offset Optional: additional offset
     * @returns {boolean}
     */
    isTop(offset) {
        return offset ? this.win.scrollTop() <= offset : this.win.scrollTop() === 0;
    }

    /**
     *  Returns true if an element is fully visible in viewport, false otherwise
     *  If there are multiple elements with the same selector, this method computes just the first one
     *
     * @param {string|object} element The selector used by jQueryor the jQuery element
     * @returns {boolean}
     */
    hasElementFull(element) {
        return this.hasElementTop(element) && this.hasElementBottom(element);
    }

    /**
     *  Returns true if the top of an element is fully visible in viewport, false otherwise.
     *  If there are multiple elements with the same selector, this method computes just the first one
     *
     * @param {string|object} element The selector used by jQuery or the jQuery element
     * @returns {boolean}
     */
    hasElementTop(element) {
        const $element = typeof element === 'string'
            ? this.$(element)
            : element;
        const viewportTop = this.win.scrollTop();
        const viewportBottom = viewportTop + this.win.height();

        if (!$element.length) {
            return false;
        }

        const elementTop = $element.offset().top;

        return elementTop <= viewportBottom && elementTop >= viewportTop;
    }

    /**
     *  Returns true if the bottom of an element is fully visible in viewport, false otherwise.
     *  If there are multiple elements with the same selector, this method computes just the first one
     *
     * @param {string|object} element The selector used by jQuery or the jQuery element
     * @returns {boolean}
     */
    hasElementBottom(element) {
        const $element = typeof element === 'string'
            ? this.$(element)
            : element;
        const viewportTop = this.win.scrollTop();
        const viewportBottom = viewportTop + this.win.height();

        if (!$element.length) {
            return false;
        }

        const elementTop = $element.offset().top;
        const elementBottom = elementTop + $element.outerHeight();

        return elementBottom <= viewportBottom && elementBottom >= viewportTop;
    }

    /**
     * Returns true if the element is completely above the viewport
     *
     * @param {string|object} element The selector used by jQuery or the jQuery element
     * @returns {boolean}
     */
    isElementAboveViewport(element) {
        const $element = typeof element === 'string'
            ? this.$(element)
            : element;
        const viewportTop = this.win.scrollTop();

        return $element.length
            ? viewportTop > ($element.offset().top + $element.height())
            : false;
    }

    /**
     * Returns true if the element is completely below the viewport
     *
     * @param {string|object} element The selector used by jQuery or the jQuery element
     * @returns {boolean}
     */
    isElementBelowViewport(element) {
        const $element = typeof element === 'string'
            ? this.$(element)
            : element;
        const viewportTop = this.win.scrollTop();

        return $element.length
            ? viewportTop + this.winHeight < ($element.offset().top)
            : false;
    }

    /**
     * Returns true if part of the element is inside the viewport
     *
     * @param {string|object} element The selector used by jQuery or the jQuery element
     * @returns {boolean}
     */
    isElementInViewport(element) {
        return (!this.isElementAboveViewport(element) && !this.isElementBelowViewport(element));
    }

    /**
     *  Returns an object representing the size of the window with width and height properties.
     *
     * @returns {object}
     */
    getSize() {
        return {
            width: this.winWidth,
            height: this.winHeight,
        };
    }
}
